import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { StationsRepo } from 'src/app/repositories/stations/repo/station-repo';
import { ConfiguredGraph, Station } from 'src/swagger-gen/web-secured/models';

@Component({
    selector: 'app-modal-remove-configured-graph',
    templateUrl: './modal-remove-configured-graph.component.html',
    styleUrls: ['./modal-remove-configured-graph.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalRemoveConfiguredGraphComponent implements OnInit {

  
  configuredGraph: ConfiguredGraph;
  station: Station;

  loading = false;
  deleteSuccess: any;
  deleteError: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private stationRepo: StationsRepo, private translate: TranslateService) {
    this.configuredGraph = this.data.configuredGraph;
    this.station = this.data.station;
   }

  ngOnInit(): void {
  }

  removeConfiguredGraph() {
    this.stationRepo.deleteGraph(this.station.uid, this.configuredGraph.uid).toPromise()
    .then(() => {
      this.deleteSuccess = this.translate.instant('stations.configuredGraphs.modal.modalRemoveGraph.deleteSuccess');
    })
    .catch((error) => {
      this.deleteError = this.translate.instant('stations.configuredGraphs.modal.modalRemoveGraph.deleteError');
      console.error(error);
    })

  }

}
